<script>
import { BDropdownHeader } from "bootstrap-vue";

export default {
  extends: BDropdownHeader
};
</script>